import React from "react";
import { useMediaQuery } from "react-responsive";
import { CancellationType } from "../../enums";
import { CancellationPerks } from "../../types";
import DesktopPerksMatrix from "./DesktopPerksMatrix";
import MobilePerksMatrix from "./MobilePerksMatrix";
import "./CancellationPerksMatrix.scss";

interface Props {
  cancellationPerks: CancellationPerks;
  onChangeCancellationType: (cancellationType: CancellationType) => void;
  selectedCancellationType?: CancellationType;
}

const CancellationPerksMatrix = ({
  cancellationPerks,
  onChangeCancellationType,
  selectedCancellationType,
}: Props) => {
  const isMinTablet = useMediaQuery({ minWidth: 768 });

  return (
    <div className="cancellation-perks-matrix">
      {isMinTablet ? (
        <DesktopPerksMatrix
          cancellationPerks={cancellationPerks}
          onChangeCancellationType={onChangeCancellationType}
          selectedCancellationType={selectedCancellationType}
        />
      ) : (
        <MobilePerksMatrix
          cancellationPerks={cancellationPerks}
          onChangeCancellationType={onChangeCancellationType}
          selectedCancellationType={selectedCancellationType}
        />
      )}
    </div>
  );
};

export default CancellationPerksMatrix;
